import React from 'react';
import { Layout } from 'antd';
import moment from 'moment';

const FooterView: React.FC = () => {
  return (
    <Layout.Footer style={{ textAlign: 'center' }}>
      &copy; {moment().format('Y')}
      {' - '}
      <span>{process.env.REACT_APP_APP_NAME ?? ''}</span> All rights reserved to{' '}
      <a href="https://www.paycall.co.il/" target="_blank" rel="noreferrer">
        <strong>Paycall Technologies Ltd.</strong>
      </a>
    </Layout.Footer>
  );
};

export default FooterView;
